import { useEffect } from "react";
import Header from "../../components/Header";
import Breadcrumbs from "../../components/Breadcrumbs";
import { AboutContent } from "../../components/Content";
import Footer from "../../components/Footer";
const AboutFoundation = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };
    scrollToTop();
    window.addEventListener("load", scrollToTop);
    return () => {
      window.removeEventListener("load", scrollToTop);
    };
  }, []);
  return (
    <>
      <Header />
      <Breadcrumbs
        currentPage="About Foundation"
        pageHeading="About Charity Foundation Organization"
      />
      <AboutContent />
      <Footer />
    </>
  );
};

export default AboutFoundation;
